/* eslint-disable react/react-in-jsx-scope */

export default (tabs) => {
  if (tabs) {
    const paymentTypes = tabs.map(data => (data === "CREDIT_CARD_NOT_PRESENT" || data === "DEBIT_CARD_NOT_PRESENT" || data === "DEBIT_CARD_PRESENT" || data === "CREDIT_CARD_PRESENT" || data === "RUPAY_PRESENT" || data === "RUPAY_NOT_PRESENT" || data === 'AMEX_NOT_PRESENT' || data === 'AMEX_PRESENT')
      ? "CARD" : data === 'UPI_NOT_PRESENT' ? "UPI" : data.includes("NET_BANKING") ? "NET_BANKING" : data);
    const uniquePaymentTypes = [...new Set(paymentTypes)];
    return uniquePaymentTypes;
  }
};